import { UserCalendarProvider } from 'generated-graphql/hooks/apollo-hooks';
import { UseUserCalendarReturnData } from 'modules/calendar/hooks/useUserCalendar';

// The form schema types participants as `(string | undefined)[] | undefined`,
// so the blanks are dropped here rather than cast away at each call site.
export const convertFromParticipantsToParticipants = (
  participants: (string | undefined)[] | undefined,
  userCalendars: UseUserCalendarReturnData
) => {
  return (participants ?? [])
    .filter((id): id is string => Boolean(id))
    .map((participantId) => {
      const participant = userCalendars.find(
        (userCalendar) => userCalendar.id === participantId
      );
      if (!participant) {
        throw new Error('Participant not found');
      }
      const isVirtualCalendar =
        participant.provider === UserCalendarProvider.Virtual;
      return {
        id: participant.id,
        email: participant.email,
        name: participant.name,
        isOrganizer: false,
        provider: participant.provider,
        nylasVirtualCalendarId: participant.nylasVirtualCalendarId,
        ...(isVirtualCalendar && { autoCollectAvailability: true })
      };
    });
};
